<template>
  <label
    :class="[
      'p-checkbox',
      { checked: value, disabled: disabled || !active, error },
    ]"
  >
    <input
      v-bind="$attrs"
      type="checkbox"
      class="checkbox"
      :checked="value"
      :disabled="disabled"
      @change="onChange"
    />
    <span v-if="label" class="text" :class="labelClass">
      {{ label }}
    </span>
  </label>
</template>

<script lang="ts">
export default defineComponent({
  name: 'PCheckbox',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: 'text-body-m-book',
    },
    error: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['input', 'change'],
  setup(props, { emit }) {
    function onChange(): void {
      emit('input', !props.value);
      emit('change', !props.value);
    }

    return {
      onChange,
    };
  },
});
</script>

<style scoped lang="scss" src="./p-checkbox-scss.scss" />
